import { useMediaQuery } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import hamburgerMenuIcon from "assets/admin/hamburgerMenu.svg";
import logoutIcon from "assets/admin/logout.svg";
import profileIcon from "assets/admin/profile.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useStore from "store";
import classes from "./style.module.scss";

import { LazyLoadImage } from "react-lazy-load-image-component";

const Appbar = ({ title }) => {
  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width:700px)");

  const userInfo = useStore((state) => state.userInfoStore);
  const storeLogout = useStore((state) => state.storeLogout);
  const { storeSetSidebarOpening, sidebarOpenStore } = useStore();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const logoutHandler = () => {
    storeLogout();
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = "https://its.iust.ac.ir/user/logout";
    document.body.appendChild(iframe);
    setTimeout(() => {
      navigate("/oauth");
    }, 1000);
  };

  return (
    <>
      <AppBar position="sticky" elevation={4} className={classes.mainNavbar}>
        <Toolbar className={classes.navbarBox}>
          <div className={classes.headerTitleSec}>
            <IconButton onClick={() => storeSetSidebarOpening(!sidebarOpenStore)}>
              <LazyLoadImage src={hamburgerMenuIcon} style={{ width: "1.8rem" }} />
            </IconButton>
            <Typography className={classes.navbarTitle}>{title}</Typography>
          </div>
          {isMobile ? (
            <div className={classes.accountBox}>
              <div className={classes.profileBox}>
                <IconButton onClick={handleClick}>
                  <LazyLoadImage
                    src={userInfo?.profile_url ?? profileIcon}
                    className={classes.profileImage}
                  />
                </IconButton>
              </div>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                className={classes.mobileMenu}
              >
                <MenuItem className={classes.mobileProfileFullName}>
                  {" "}
                  {userInfo?.full_name}
                </MenuItem>
                <MenuItem>کد پرسنلی: {userInfo?.sub}</MenuItem>
                <MenuItem onClick={logoutHandler}>
                  <LazyLoadImage src={logoutIcon} className={classes.mobileLogoutImage} />
                  خروج
                </MenuItem>
              </Menu>
            </div>
          ) : (
            <div className={classes.accountBox}>
              <div className={classes.profileBox}>
                <LazyLoadImage
                  src={userInfo?.profile_url ?? profileIcon}
                  className={classes.profileImage}
                />
                <div className={classes.profileDetail}>
                  <Typography variant="subtitle1" noWrap className={classes.profileFullName}>
                    {userInfo?.full_name}
                  </Typography>
                  <Typography className={classes.personalCode} variant="body2" noWrap>
                    <span>کد پرسنلی:</span>
                    <span>{userInfo?.sub}</span>
                  </Typography>
                </div>
              </div>
              <Tooltip title="خروج">
                <IconButton onClick={logoutHandler}>
                  <LazyLoadImage src={logoutIcon} className={classes.logoutImage} />
                </IconButton>
              </Tooltip>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Appbar;
